import { ref } from 'vue';
import types from '@/actions/types';
import Navigation from '@/actions/navigation';
import Say from '@/actions/say';
import Pause from '@/actions/pause';
import RandomFlow from '@/actions/randomFlow';
import Website from '@/actions/website';
import Home from '@/actions/home';
import ApiCall from '@/actions/apiCall';
import SetVariable from '@/actions/setVariable';
import ResetVariable from '@/actions/resetVariables';
import Condition from '@/actions/condition';
import QrReader from '@/actions/qrReader';
import RobotCommand from '@/actions/robotCommand';
import R2RChat from '@/actions/r2rChat';
import RobotAction from '@/actions/robotAction';
import ChangeLanguage from '@/actions/changeLanguage';
import CustomScript from '@/actions/customScript';
import ResetKnowledgeBase from '@/actions/resetKnowledgeBase';
import KnowledgeBase from '@/actions/knowledgeBase';

const currentAction = ref(null);

const actions = {
  [types.RANDOM_FLOW]: RandomFlow,
  [types.SAY]: Say,
  [types.PAUSE]: Pause,
  [types.NAVIGATION]: Navigation,
  [types.WEBSITE]: Website,
  [types.HOME]: Home,
  [types.API_CALL]: ApiCall,
  [types.SET_VARIABLE]: SetVariable,
  [types.RESET_VARIABLE]: ResetVariable,
  [types.CONDITION]: Condition,
  [types.QR_READER]: QrReader,
  [types.ROBOT_COMMAND]: RobotCommand,
  [types.R2R_CHAT]: R2RChat,
  [types.ROBOT_ACTION]: RobotAction,
  [types.CHANGE_LANGUAGE]: ChangeLanguage,
  [types.CUSTOM_SCRIPT]: CustomScript,
  [types.RESET_KNOWLEDGE_BASE]: ResetKnowledgeBase,
  [types.KNOWLEDGE_BASE]: KnowledgeBase,
};

export default function useActions() {
  function createAction(action, params, { sequenceId, sequenceIndex }) {
    if (actions[action]) {
      return new actions[action]({ ...params, sequenceId, sequenceIndex });
    }
    return null;
  }
  function setAction({ action, params }, { sequenceId, sequenceIndex }) {
    if (actions[action]) {
      currentAction.value = createAction(action, params, { sequenceId, sequenceIndex });
    }
  }

  return {
    setAction,
    currentAction,
    createAction,
  };
}
